import React from 'react';
import { DEFAULT_THUMB_URL } from '../utils/storage';

function AboutUs({ lang }) {
  const aboutText = {
    es: `¡Bienvenidos a CAMITEX! Somos una orgullosa empresa textil costarricense, nacida de la pasión por la calidad y el compromiso de impulsar a emprendedores y empresas locales. Desde nuestros inicios, nos hemos dedicado a ser más que un simple proveedor de textiles; nos esforzamos por ser un socio de confianza en tu camino, brindando los productos de calidad fundamentales y las soluciones textiles innovadoras que necesitas para hacer realidad tus visiones.

En un mundo de producción masiva, CAMITEX se distingue por enfocarse en las necesidades únicas de cada cliente. Entendemos los desafíos y los éxitos que conlleva construir un negocio, y por eso volcamos nuestra experiencia en cada hilo y cada servicio que ofrecemos. Desde la obtención de materiales de primera calidad hasta la provisión de soluciones textiles a medida, nuestro equipo está comprometido con la excelencia, asegurando que tus proyectos no solo cumplan, sino que superen las expectativas.

En CAMITEX, creemos en fomentar relaciones sólidas construidas sobre la fiabilidad, la transparencia y el éxito mutuo. Nuestras raíces en Costa Rica nos inspiran a contribuir a la economía local y apoyar el vibrante espíritu emprendedor de nuestra comunidad. Cuando eliges CAMITEX, no solo obtienes un producto; ganas un aliado dedicado, comprometido en ayudar a que tu negocio florezca.`,
    en: `Welcome to CAMITEX, a proud Costa Rican textile company born from a passion for quality and a commitment to empowering local entrepreneurs and businesses. Since our inception, we've dedicated ourselves to being more than just a textile supplier; we strive to be a trusted partner in your journey, providing the foundational quality products and innovative textile solutions you need to bring your visions to life.

In a world of mass production, CAMITEX stands apart by focusing on the unique needs of each client. We understand the challenges and triumphs that come with building a business, and that's why we pour our expertise into every thread and every service we offer. From sourcing premium materials to providing tailored textile solutions, our team is committed to excellence, ensuring that your projects not only meet but exceed expectations.

At CAMITEX, we believe in fostering strong relationships built on reliability, transparency, and mutual success. Our roots in Costa Rica inspire us to contribute to the local economy and support the vibrant entrepreneurial spirit of our community. When you choose CAMITEX, you're not just getting a product; you're gaining a dedicated ally, invested in helping your business flourish.`
  };

  const paragraphs = aboutText[lang].split('\n\n');

  return (
    <section
      className="about-section"
      style={{
        background: 'linear-gradient(135deg, #f8fafc 95%,rgb(226, 86, 109) 100%)',
        borderRadius: 16,
        padding: '32px 24px',
        margin: '32px auto',
        maxWidth: 800,
        boxShadow: '0 4px 24px rgba(0,0,0,0.07)',
        color: '#222',
        position: 'relative'
      }}
    >
      <h2
        style={{
          color: '#e60026',
          fontWeight: 800,
          fontSize: 32,
          marginBottom: 16,
          letterSpacing: 1
        }}
      >
        {lang === 'es' ? 'Sobre Nosotros' : 'About Us'}
      </h2>
      <div style={{ marginBottom: 24 }}>
        <img
          src={DEFAULT_THUMB_URL}
          alt="CAMITEX Logo"
          style={{
            width: 90,
            height: 90,
            borderRadius: '50%',
            objectFit: 'cover',
            marginBottom: 16,
            border: '3px solid #e60026',
            background: '#fff',
            boxShadow: '0 2px 8px rgba(230,0,38,0.08)'
          }}
        />
      </div>
      <div style={{ fontSize: 18, lineHeight: 1.7 }}>
        {paragraphs.map((p, i) => (
          <p key={i} style={{ marginBottom: 18 }}>
            {p}
          </p>
        ))}
      </div>
      <div
        style={{
          position: 'absolute',
          bottom: 24,
          right: 32,
          fontWeight: 600,
          color: '#e60026',
          opacity: 0.12,
          fontSize: 64,
          pointerEvents: 'none',
          userSelect: 'none',
          letterSpacing: 2
        }}
      >
        CAMITEX
      </div>
    </section>
  );
}

export default AboutUs;